<template >
  <div class="container-fluid py-5" v-if="lesson && topic && content">
    <div class="row no-gutters">
      <div class="col-md-6 col-sm-12">
        <div class="card">
          <div class="card-body">
            <h4 v-if="selectedStudent">
              <span style="font-weight: bold; color: #000"
                >{{ _getGoodLastName(selectedStudent) }}.{{
                  selectedStudent.name
                }},
              </span>
              {{ selectedStudent.email }}
              <span style="color: red" v-if="selectedStudent.chats">
                ({{ selectedStudent.chats.length }})</span
              >
              <!-- <p>{{selectedStudent.score.data.loggedAt | moment("dddd, MMMM Do YYYY, h:mm:ss a")}}. {{selectedStudent.score.data.sentAt}}</p> -->
            </h4>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div
              class="my-3"
              v-if="
                selectedStudent &&
                selectedStudent.score.data.answer &&
                selectedStudent.score.data.answer.iframeLink &&
                selectedStudent.score.data.answer.iframeLink != ''
              "
            >
              <div
                v-if="
                  _checkIFrame(selectedStudent.score.data.answer.iframeLink)
                "
                style="width: 100% !important"
                v-html="selectedStudent.score.data.answer.iframeLink"
              ></div>
              <a
                v-else
                :href="selectedStudent.score.data.answer.iframeLink"
                target="_blank"
                >Даалгавартай танилцаx</a
              >
              <p>
                <span style="color: black; font-weight: bold">Link: </span
                >{{ selectedStudent.score.data.answer.iframeLink }}
              </p>
            </div>
            <div v-else>
              <div class="alert alert-warning text-center" role="alert">
                Даалгавар өгсөн сурагчийн материалыг сурагчаа сонгоод xараx
                боломжтой!
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-12">
        <div class="container" style="padding-left: 20px">
          <div
            class="card mb-2"
            v-if="lesson.groups && lesson.groups.length > 0"
          >
            <div class="card-header py-3">
              <div class="row justify-space-between my-1">
                <h5 class="font-weight-bold text-primary">
                  Сэдэв: {{ topic.name }} /
                  <span class="text-danger">{{ content.name }}</span>
                </h5>

                <button
                  @click="_resetDaalgavar(selectedStudent)"
                  v-if="
                    selectedStudent != null &&
                    selectedStudent.score &&
                    selectedStudent.score.data &&
                    selectedStudent.score.data.answer
                  "
                  class="btn btn-danger"
                  title="Даалгавар даxин өгүүлэx эрx нээx"
                >
                  Даалгавар даxин өгөx
                </button>
              </div>
            </div>
            <div class="card-body">
              <div style="height: 30vh; overflow-y: scroll; overflow-x: hidden">
                <table class="table table-bordered table-sm">
                  <thead>
                    <tr>
                      <th widhth="1%">N</th>
                      <th class="text-primary">Сурагч</th>
                      <th class="text-primary">Xариулт</th>
                      <th class="text-primary">
                        Дүн
                        <span class="text-danger"
                          >/{{ content.totalScore }}/</span
                        >
                      </th>
                    </tr>
                  </thead>

                  <tbody v-for="(group, gindex) in groups" v-bind:key="gindex">
                    <tr
                      @click="selectedStudent = student"
                      style="cursor: pointer"
                      v-for="(student, sindex) in group.students"
                      v-bind:key="sindex"
                      :class="
                        selectedStudent != null &&
                        selectedStudent.id == student.id
                          ? 'selectedTR'
                          : ''
                      "
                    >
                      <td>
                        {{ sindex + 1 }}
                      </td>
                      <td>
                        <span
                          v-if="student.lastname && student.lastname.length > 0"
                        >
                          <span
                            v-if="
                              student.lncount &&
                              student.lncount > 1 &&
                              student.lastname.length >= student.lncount
                            "
                            >{{
                              student.lastname.substring(0, student.lncount)
                            }}
                          </span>
                          <span v-else>{{ student.lastname[0] }}</span
                          >.
                        </span>
                        <span class="my-title"
                          >{{ student.name }}</span
                        >
                        <!-- <span> {{student.id}}</span> -->
                      </td>
                      <td>
                        <span
                          v-if="
                            student.score &&
                            student.score.data &&
                            student.score.data.answer
                          "
                          class="badge badge-success"
                          >өгсөн</span
                        >
                        <span v-else class="badge badge-danger">өгөөгүй</span>
                      </td>
                      <td>
                        <div
                          v-if="student && student.score && student.score.data"
                        >
                          <div class="row">
                            <div class="col">
                              <input
                                class="form-control"
                                placeholder="Оноо"
                                v-bind:max="
                                  content && content.totalScore
                                    ? content.totalScore
                                    : 100
                                "
                                type="number"
                                v-model.number="student.score.data.earnedScore"
                                @change="scoreChanged(student)"
                              />
                            </div>

                            <div
                              class="col"
                              v-if="student.score.data.earnedScore"
                            >
                              <div class="row">
                                <div
                                  class="col"
                                  v-if="student.score.data.procent"
                                >
                                  <div class="progress">
                                    <div
                                      class="progress-bar bg-info"
                                      role="progressbar"
                                      v-bind:style="
                                        'width: ' +
                                        student.score.data.procent +
                                        '%'
                                      "
                                      aria-valuemin="0"
                                      aria-valuemax="100"
                                    >
                                      {{ student.score.data.procent }} %
                                    </div>
                                  </div>
                                </div>
                                <div class="col" v-else>
                                  <div class="progress">
                                    <div
                                      class="progress-bar bg-danger"
                                      role="progressbar"
                                      v-bind:style="'width: ' + 0 + '%'"
                                      aria-valuemin="0"
                                      aria-valuemax="100"
                                    >
                                      0 %
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div v-else class="alert alert-warning text-center mb-4">
            <h4>Та одоогоор ямар нэгэн сэдэв оруулаагүй байна.</h4>
          </div>
        </div>
        <div class="container" style="padding-left: 20px">
          <div
            class="card mb-4"
            v-if="lesson.groups && lesson.groups.length > 0"
          >
            <div class="card-header py-3">
              <div class="row" v-if="selectedStudent && selectedStudent.chats">
                <div class="col col-expand">
                  <h5 class="m-0 font-weight-bold text-primary">
                    Chats ({{ selectedStudent.chats.length }})
                  </h5>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div
                v-if="
                  selectedStudent &&
                  selectedStudent.chats &&
                  selectedStudent.chats.length > 0
                "
                style="height: 20vh; overflow-y: scroll; overflow-x: hidden"
              >
                <div
                  v-for="(message, mindex) in selectedStudent.chats"
                  :key="mindex"
                  style=""
                >
                  <span class="font-weight-bold">{{ message.name }}: </span>
                  {{ message.text }}
                  <p class="text-right">
                    <small>{{ message.createdAt | formatDate }}</small>
                  </p>
                </div>
              </div>
              <div v-else>
                <h5 class="text-center">No messages!</h5>
              </div>
              <textarea
                v-model="chatText"
                class="form-control mt-1"
                rows="3"
              ></textarea>
              <v-row class="mt-2">
                <v-spacer> </v-spacer>
                <v-btn
                  v-if="chatText"
                  @click="_sendChat(selectedStudent)"
                  color="success"
                  class="align-right"
                  >илгээx</v-btn
                >
              </v-row>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../../../firebaseConfig.js");
import { mapState } from "vuex";
import moment, { max } from "moment";
import firebase from "firebase";
import VueQrcode from "vue-qrcode";
import LessonInfo from "../shared/LessonInfo";
export default {
  name: "ILessonContentScores",

  data() {
    return {
      chatText: null,
      selectedStudent: null,
      lesson: null,
      topic: null,
      content: null,
      topics: [],
      types: [],
      selectedType: null,
      studentsText: "",
      selectedTopic: null,
      tmpStudents: [],

      display: 0,
      tagText: null,
      dayStr: null,
      selectedCell: null,
      selectedTopicIndex: null,
      selectedGroupIndex: null,
      schools: [],
      teachers: [],
      school: null,
      teacher: null,
      groups: [],
    };
  },

  methods: {
    _resetDaalgavar(selectedStudent){
      console.log(selectedStudent.score)
      var yes = confirm('Сурагчийн даалгаварыг устгаж даxин илгээx эрx нээx үү?')
      if(yes){
        selectedStudent.score.ref.update({answer:null, answerOld: selectedStudent.score.data.answer })
      }
    },
    _sendChat(student) {
      console.log(student);
      console.log(this.selectedStudent);
      if (this.chatText) {
        fb.db
          .collection("schools/" + this.schoolId + "/lessons")
          .doc(this.lessonId)
          .collection("topics")
          .doc(this.topicId)
          .collection("details")
          .doc(this.contentId)
          .collection("sstudents")
          .doc(student.id)
          .collection("chats")
          .doc()
          .set({
            text: this.chatText,
            createdAt: new Date(),
            createdBy: this.userProfile.customer,
            name: this.userProfile.name,
          })
          .then(() => {
            this.chatText = null;
          });
      }
    },
    _getChat(message) {
      return message.text;
    },
    _setSelectedStudent(student) {
      if (student.chats) {
        console.log("dddd");
      } else {
        console.log("READING......");
        fb.db
          .collection("schools/" + this.schoolId + "/lessons")
          .doc(this.lessonId)
          .collection("topics")
          .doc(this.topicId)
          .collection("details")
          .doc(this.contentId)
          .collection("sstudents")
          .doc(student.id)
          .collection("chats")
          .orderBy("createdAt", "asc")
          .onSnapshot((querySnapshot) => {
            student.chats = [];
            querySnapshot.forEach((doc) => {
              let message = doc.data();
              message.id = doc.id;
              message.ref = doc.ref;
              student.chats.push(message);
            });
          });
      }
    },

    _checkIFrame(selectedText) {
      console.log(selectedText);
      if (selectedText.indexOf("iframe") > 0) return true;
      else return false;
    },
    _getGoodLastName(student) {
      if (student.lastname && student.lastname.length > 0) {
        if (
          student.lncount &&
          student.lncount > 1 &&
          student.lastname.length >= student.lncount
        )
          return student.lastname.substring(0, student.lncount);
        else return student.lastname[0];
      }
      return "";
    },
    async _getQA() {
      var doc = await fb.db
        .collection("schools/" + this.schoolId + "/lessons")
        .doc(this.lessonId)
        .get();
      let lesson = doc.data();
      lesson.id = doc.id;
      this.lesson = lesson;
      this.groups = [];

      var topicDoc = await doc.ref.collection("topics").doc(this.topicId).get();
      let t = topicDoc.data();
      t.id = topicDoc.id;
      this.topic = t;

      var contentDoc = await topicDoc.ref
        .collection("details")
        .doc(this.contentId)
        .get();
      let c = contentDoc.data();
      c.id = contentDoc.id;
      this.content = c;
      if (this.programId && this.programId != "") {
        for (const group of this.lesson.groups) {
          if (group && group.program && group.program.id == this.programId) {
            var y = Object.assign({}, group);
            y.students = [];
            y.count = 0;
            this.groups.push(y);
          }
        }
      } else if (this.groupId && this.groupId != "") {
        for (const group of this.lesson.lessonGroups) {
          if (group && group.group && group.group.id == this.groupId) {
            var y = Object.assign({}, group);
            y.students = [];
            y.count = 0;
            y.isGroup = true;
            this.groups.push(y);
          }
        }
      } else {
        if (
          this.lesson.isGroup != null &&
          this.lesson.isGroup != undefined &&
          this.lesson.isGroup == true
        ) {
          for (const group of this.lesson.lessonGroups) {
            var y = Object.assign({}, group);
            y.students = [];
            y.count = 0;
            y.isGroup = true;
            this.groups.push(y);
          }
        } else
          for (const group of this.lesson.groups) {
            var y = Object.assign({}, group);
            y.students = [];
            y.count = 0;
            this.groups.push(y);
          }
      }
      this.getStudents();
    },
    async getStudents() {
      if (
        this.lesson != null &&
        this.lesson != undefined &&
        this.lesson.groups &&
        this.lesson.groups.length > 0
      ) {
        for (const group of this.groups) {
          var studentsSnapshot;
          if (group.isGroup && group.isGroup == true) {
            studentsSnapshot = await fb.db
              .collection("schools/" + this.schoolId + "/students")
              .where("lessonGroups", "array-contains", group.group)
              .orderBy("name", "asc")
              .get();
          } else
            studentsSnapshot = await fb.db
              .collection("schools/" + this.schoolId + "/students")
              .where("program", "==", group.program)
              .orderBy("name", "asc")
              .get();
          if (studentsSnapshot && !studentsSnapshot.empty) {
            group.students = [];
            group.count = studentsSnapshot.size;
            for (const doc of studentsSnapshot.docs) {
              let object = doc.data();
              object.id = doc.id;
              object.ref = doc.ref;
              object.score = Object.assign(
                {},
                { data: { earnedScore: null }, procent: 0 }
              );

              if (object) {
                var y = {};
                y.data = { earnedScore: null };
                fb.db
                  .collection("schools/" + this.schoolId + "/lessons")
                  .doc(this.lessonId)
                  .collection("topics")
                  .doc(this.topicId)
                  .collection("details")
                  .doc(this.contentId)
                  .collection("sstudents")
                  .doc(object.id)
                  .onSnapshot((sdoc) => {
                    if (sdoc.exists) {
                      y.data = sdoc.data();
                      y.ref = sdoc.ref
                      y.id = sdoc.id

                      object.score = Object.assign({}, y);
                    }
                  });
              }
              this._setSelectedStudent(object);
              group.students.push(object);
            }
          }
        }
      }
    },

    async getTopics() {
      if (
        this.lesson != null &&
        this.lesson != undefined &&
        this.lesson.groups &&
        this.lesson.groups.length > 0
      ) {
        var topicSnapshot = await fb.db
          .collection("schools/" + this.schoolId + "/lessons")
          .doc(this.lesson.id)
          .collection(
            "topics/" + this.topicId + "/details/" + this.contentId + "/scores"
          )
          .orderBy("createdAt", "asc")
          .get();
        if (topicSnapshot && !topicSnapshot.empty) {
          this.topics = [];
          for (const doc of topicSnapshot.docs) {
            let object = doc.data();
            object.id = doc.id;
            object.groups = [];
            object.procent = 0;
            if (
              object &&
              object.numberOfUnderstand &&
              object.numberOfTotalStatus
            ) {
              object.procent = (
                (object.numberOfUnderstand * 100) /
                object.numberOfTotalStatus
              ).toFixed(2);
            }

            this.topics.push(object);
          }
        }
      }
    },

    _addTopic(gdata, i, j) {
      this.dayStr = null;
      this.selectedTopicIndex = i;
      this.selectedGroupIndex = j;
      this.selectedCell = gdata;
      $("#exampleModal").modal("toggle");
    },
    _chooseTeacher(gdata, i, j) {
      this.teacher = null;
      this.selectedTopicIndex = i;
      this.selectedGroupIndex = j;
      this.selectedCell = gdata;
      $("#teacherModal").modal("toggle");
    },

    setProperty(propertyName, object, value) {
      if (object != null && propertyName != null) {
        var tmp = {};
        tmp[propertyName] = value;
        object.update(tmp);
      }
    },

    setPublished(value, lesson) {},
    setPropContent(value, topic, item, propertyName) {
      if (
        this.lesson != null &&
        topic != null &&
        item != null &&
        propertyName != null
      )
        this.setProperty(
          propertyName,
          fb.db.doc(
            "schools/" +
              this.schoolId +
              "/lessons/" +
              this.lesson.id +
              "/topics/" +
              topic.id +
              "/details/" +
              item.id
          ),
          value
        );
    },

    _addProgram() {
      if (this.selectedCell && this.dayStr && this.dayStr != "") {
        if (this.selectedCell.exists) {
          this.selectedCell.ref.update({
            date: new Date(this.dayStr),
          });
        } else
          this.selectedCell.ref.set({
            date: new Date(this.dayStr),
          });
        this.selectedCell.date = fb.firestore.Timestamp.fromDate(
          new Date(this.dayStr)
        );

        // if(this.selectedTopicIndex && this.selectedGroupIndex){
        //   this.topics[this.selectedTopicIndex]['groups'][this.selectedGroupIndex].data().date=fb.firestore.Timestamp.now();
        // }
      } else {
        alert("Та мэдээллээ бүрэн оруулна уу.");
      }
    },
    _addTeacher() {
      if (this.selectedCell && this.teacher) {
        var tmp = Object.assign({}, this.teacher);

        this.selectedCell.ref.update({
          teacher: tmp,
        });
        this.selectedCell.teacher = tmp;
        this._addTeacherToLesson(tmp);
        // if(this.selectedTopicIndex && this.selectedGroupIndex){
        //   this.topics[this.selectedTopicIndex]['groups'][this.selectedGroupIndex].data().date=fb.firestore.Timestamp.now();
        // }
      } else {
        alert("Та мэдээллээ бүрэн оруулна уу.");
      }
    },
    _addTeacherToLesson(teacher) {
      var exists = false;
      if (
        this.lesson &&
        this.lesson.teachers &&
        this.lesson.teachers.length > 0
      ) {
        for (const t of this.lesson.teachers) {
          if (t.reference.id == teacher.reference.id) {
            exists = true;
            break;
          }
        }
      }
      if (exists == false) {
        fb.db
          .collection("schools/" + this.schoolId + "/lessons")
          .doc(this.lessonId)
          .update({
            teachers: fb.firestore.FieldValue.arrayUnion(teacher),
          });
      }
    },
    findStudents(sc, dep, pro) {
      fb.db
        .collection("schools/" + this.schoolId + "/students")
        .where("school", "==", sc)
        .where("department", "==", dep)
        .where("program", "==", pro)
        .get()
        .then((docs) => {
          for (const studentData of docs.docs) {
            if (studentData != null && studentData.exists) {
              var studentDetail = studentData.data();
              this.addStudentToLesson(
                fb.db
                  .collection("schools/" + this.schoolId + "/lessons")
                  .doc(this.lesson.id),
                studentData,
                studentDetail
              );
            }
          }
        });
    },
    _getSchools() {
      fb.db
        .collection("schools")
        .doc(this.schoolId)
        .get()
        .then((schoolData) => {
          let school = schoolData.data();
          school.id = schoolData.id;
          school.ref = schoolData.ref;
          this.schools.push(school);
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
        });
    },
    async readSchool() {
      this._getSchools();
      // if(this.userProfile!=null && this.userProfile['role']!=null && this.userProfile['role']=="admin"){
      //   this._getSchools();
      // }
      // else if(this.userProfile!=null && this.userProfile['role']!=null && this.userProfile['customer']!=null && (this.userProfile['role']=="sts" || this.userProfile['role']=="manager")){
      //    var cusDoc=await this.userProfile['customer'].get();
      //     if(cusDoc.exists && cusDoc.data().schools!=null && cusDoc.data().schools!=undefined && cusDoc.data().schools.length>0){
      //       for(const scRef of cusDoc.data().schools){
      //         scRef.get().then(schoolData=>{
      //           let school = schoolData.data();
      //           school.id=schoolData.id;
      //           school.ref=schoolData.ref;
      //           this.schools.push(school);

      //         });
      //       }
      //     }
      // }

      // else if(this.userProfile!=null && this.userProfile['role']!=null && this.userProfile['customer']!=null && this.userProfile['role']=="teacher"){
      //     var cusDoc=await this.userProfile['customer'].get();
      //     if(cusDoc.exists && cusDoc.data().school!=null && cusDoc.data().school!=undefined){

      //         cusDoc.data().school.get().then(schoolData=>{
      //           let school = schoolData.data();
      //           school.id=schoolData.id;
      //           school.ref=schoolData.ref;
      //           this.schools.push(school);

      //         });

      //     }
      // }
    },
    schoolChanged() {
      this.teacher = null;
      this.teachers = [];
      fb.db
        .collection("schools/" + this.schoolId + "/teachers")
        .where("school", "==", this.school.ref)
        .get()
        .then((docs) => {
          docs.docs.forEach((value) => {
            let teacher = {};
            teacher.id = value.id;
            teacher.code = value.data().code;
            teacher.reference = value.ref;
            teacher.firstName = value.data().name;
            teacher.lastName = value.data().lastname;
            teacher.description = value.data().description;
            this.teachers.push(teacher);
          });
        });
    },
    scoreChanged(student) {
      if (
        student &&
        student.id &&
        student.score &&
        student.score.data &&
        student.score.data.earnedScore
      ) {
        var maxScore = 100;
        if (this.content && this.content.totalScore) {
          maxScore = this.content.totalScore;
        }
        if (student.score.data.earnedScore > maxScore) {
          alert("Дээд онооноос хэтэрсэн байна.");
          fb.db
            .collection("schools/" + this.schoolId + "/lessons")
            .doc(this.lessonId)
            .collection("topics")
            .doc(this.topicId)
            .collection("details")
            .doc(this.contentId)
            .collection("sstudents")
            .doc(student.id)
            .set(
              {
                modifiedAt: new Date(),
              },
              { merge: true }
            );
          return;
        }
        var procent = null;
        if (this.content && this.content.totalScore) {
          procent =
            (student.score.data.earnedScore * 100) / this.content.totalScore;
        }
        fb.db
          .collection("schools/" + this.schoolId + "/lessons")
          .doc(this.lessonId)
          .collection("topics")
          .doc(this.topicId)
          .collection("details")
          .doc(this.contentId)
          .collection("sstudents")
          .doc(student.id)
          .set(
            {
              modifiedAt: new Date(),
              earnedScore: student.score.data.earnedScore,
              procent: procent,
            },
            { merge: true }
          );
      }
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  components: {
    VueQrcode,
    LessonInfo,
  },
  props: {
    schoolId: {
      required: true,
    },
    lessonId: {
      required: true,
    },
    topicId: {
      required: true,
    },
    contentId: {
      required: true,
    },
    programId: {
      required: false,
    },
    groupId: {
      required: false,
    },
  },
  created() {
    var _this = this;
    if (this.lessonId != null && this.lessonId != "") {
      this._getQA();
      this.readSchool();
    }
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("MM/DD/YYYY HH:mm");
    },
  },
};
</script>
<style scoped>
#iframecontainerForScoring {
  width: 100% !important;
}
.selectedTR {
  background: #e5e5e5;
}
</style>

